export default "__VITE_ASSET__f1265ea8__"